import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { ROLES_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import AddUsersToRoleDialog from "./AddUsersToRoleDialog";
import RolesDialog from "./RolesDialog";

function Roles() {

  const [rolesData, setRolesData] = useState([]);

  useEffect(() => {
    getRoles();
  }, []);


  const getRoles = () => {
    AxiosInstance.get(ROLES_URL).then((response) =>
      setRolesData(response.data.data)
    );
  };

  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <RolesDialog roleId={0} selectedRoleName={""} callRoles={getRoles} isEdit={false} />
      </Box>

      <AppTableView
        rows={rolesData}
        cols={[
          { field: "id", headerName: "Role ID", flex: 1 },
          {
            field: "name",
            headerName: "Name",
            flex: 1,
            renderCell: (params) => (
              <RolesDialog
                roleId={params.row.id}
                selectedRoleName={params.row.name}
                callRoles={getRoles}
                isEdit={true}
              />
            ),
          },
          {
            field: "users",
            headerName: "Users",
            flex: 1,
            renderCell: (params) => (
              <AddUsersToRoleDialog
                roleId={params.row.id}
                selectedRoleName={params.row.name}
                callRoles={getRoles}
              />
            ),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}
export default Roles;
